(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deskon-bestsellers"] && !Shopify.designMode) return;
  try {
    
  /* Deskon - the Bestsellers scroll-progress bar. A scroll indicator, not a progress meter: the
     fill's WIDTH is the share of the row on screen, its OFFSET how far that view has moved. Both
     measured against scrollWidth, never the card count - here that is a fraction of the page. */
  class DeskonBestsellersCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dk-bs-track]');
      this.bar = this.querySelector('[data-dk-bs-bar]');
      this.fill = this.querySelector('[data-dk-bs-fill]');
      this.section = this.closest('.deskon-bestsellers');
      if (!this.track || !this.bar || !this.fill) return;

      this.update = this.update.bind(this);
      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.onHover = this.onHover.bind(this);

      this.track.addEventListener('scroll', this.update, { passive: true });
      /* pointerover BUBBLES, unlike pointerenter, so one listener on the carousel covers every
         card - including cards that arrive later, which a per-card listener would miss. */
      this.addEventListener('pointerover', this.onHover);
      this.bar.addEventListener('pointerdown', this.onDown);
      this.bar.addEventListener('pointermove', this.onMove);
      this.bar.addEventListener('pointerup', this.onUp);
      this.bar.addEventListener('pointercancel', this.onUp);
      this.bar.addEventListener('lostpointercapture', this.onUp);

      /* Images arrive after first paint and change scrollWidth; a resize changes the card width.
         A viewport change always changes the track's width, so this is also where the
         breakpoint-dependent settings get re-read. */
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          this.readSettings();
          this.update();
        });
        this.observer.observe(this.track);
      }

      this.readSettings();
      this.update();
    }

    /* Fills in the second photograph the first time a pointer reaches a card, and never again.
       THE REVEAL WAITS FOR THE load EVENT, not for the request: data-dk-ready is what the
       stylesheet fades in, so a slow connection shows the first image held steady rather than a
       half-drawn second one appearing under the cursor. */
    onHover(event) {
      var card = event.target.closest && event.target.closest('.deskon-bestsellers__card');
      if (!card) return;

      var img = card.querySelector('[data-dk-bs-hover]');
      if (!img || img.dataset.dkAsked === 'true') return;
      img.dataset.dkAsked = 'true';

      img.addEventListener('load', function () { img.dataset.dkReady = 'true'; }, { once: true });
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
    }

    /* The responsive values live in the stylesheet so every breakpoint stays declared in one
       place. Read into fields rather than looked up where used: getComputedStyle forces style
       resolution, and update() runs on every scroll event. */
    readSettings() {
      const styles = getComputedStyle(this);
      const scale = parseFloat(styles.getPropertyValue('--dk-bs-fill-scale'));
      const glide = parseFloat(styles.getPropertyValue('--dk-bs-bar-glide'));
      this.scale = scale > 0 && scale <= 1 ? scale : 1;
      this.smooth = parseFloat(styles.getPropertyValue('--dk-bs-bar-smooth')) === 1;
      this.glideMs = glide > 0 ? glide : 240;
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.update);
      this.removeEventListener('pointerover', this.onHover);
      if (this.observer) this.observer.disconnect();
      this.stopGlide();
    }

    update() {
      const track = this.track;
      const total = track.scrollWidth;
      if (!total) return;

      const visible = track.clientWidth;
      const maxScroll = total - visible;

      if (this.section) this.section.toggleAttribute('data-dk-bs-static', maxScroll <= 1);

      const width = Math.min(1, (visible / total) * (this.scale || 1));
      const travel = 1 - width;

      this.fill.style.width = width * 100 + '%';
      this.fill.style.insetInlineStart =
        (maxScroll > 0 ? (track.scrollLeft / maxScroll) * travel : 0) * 100 + '%';
    }

    /* Where a pointer at this x is asking the row to go. It grabs the MIDDLE of the fill, not
       its leading edge, so the fill stays under the finger instead of jumping. */
    targetFor(event) {
      const rect = this.bar.getBoundingClientRect();
      const track = this.track;
      const total = track.scrollWidth;
      const maxScroll = total - track.clientWidth;
      if (!rect.width || maxScroll <= 0) return null;

      const fillWidth = Math.min(1, (track.clientWidth / total) * (this.scale || 1)) * rect.width;
      const travel = rect.width - fillWidth;
      if (travel <= 0) return null;

      const offset = Math.max(0, Math.min(travel, event.clientX - rect.left - fillWidth / 2));
      return { raw: (offset / travel) * maxScroll, maxScroll: maxScroll };
    }

    /* The nearest whole card to a raw scroll position. Rounding the TARGET before gliding lets
       snapping come back on at the end without a second little jump.

       MEASURED FROM RECTS, NOT offsetLeft, which is relative to the nearest POSITIONED ancestor
       - the track is not positioned, so it would land the row in the wrong place. */
    nearestCard(raw, maxScroll) {
      const base = this.track.scrollLeft - this.track.getBoundingClientRect().left;
      let best = raw;
      let closest = Infinity;

      for (const item of this.track.children) {
        const at = item.getBoundingClientRect().left + base;
        const distance = Math.abs(at - raw);
        if (distance < closest) {
          closest = distance;
          best = at;
        }
      }

      return Math.max(0, Math.min(maxScroll, best));
    }

    /* A short ease-out of our own rather than scrollTo({ behavior: 'smooth' }): the native easing
       scales with distance and reaches half a second across a long row. This is fixed. */
    glideTo(target) {
      const track = this.track;
      const from = track.scrollLeft;
      const delta = target - from;

      this.stopGlide();
      if (Math.abs(delta) < 1) {
        track.scrollLeft = target;
        return;
      }

      if (this.section) this.section.setAttribute('data-dk-bs-gliding', '');

      const duration = this.glideMs || 240;
      let started = null;

      const step = (now) => {
        if (started === null) started = now;
        const t = Math.min(1, (now - started) / duration);
        /* Cubic ease-out: it leaves immediately and settles softly, which is the shape that reads
           as light. An ease-in-out would feel hesitant over so short a distance. */
        track.scrollLeft = from + delta * (1 - Math.pow(1 - t, 3));

        if (t < 1) {
          this.frame = requestAnimationFrame(step);
        } else {
          this.frame = null;
          this.stopGlide();
        }
      };

      this.frame = requestAnimationFrame(step);
    }

    stopGlide() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      if (this.section) this.section.removeAttribute('data-dk-bs-gliding');
    }

    /* PRIMARY BUTTON ONLY: a right- or middle-click emits pointerdown but sends its pointerup to
       the context menu. See onMove for why an unreported release is the danger. */
    onDown(event) {
      if (event.button !== 0 || !event.isPrimary) return;
      if (this.section && this.section.hasAttribute('data-dk-bs-static')) return;

      this.dragging = true;
      this.moved = false;
      this.downX = event.clientX;
      if (this.section) this.section.setAttribute('data-dk-bs-dragging', '');

      /* Capture keeps a drag alive past the edge of a 2px bar, but not worth an exception if
         the pointer has gone - without it the drag still works over the bar itself. */
      try {
        this.bar.setPointerCapture(event.pointerId);
      } catch (e) {}

      const spot = this.targetFor(event);
      if (!spot) return;

      if (this.smooth) this.glideTo(this.nearestCard(spot.raw, spot.maxScroll));
      else this.track.scrollLeft = spot.raw;
    }

    onMove(event) {
      /* pointermove FIRES ON HOVER, so our own flag is not enough to know a drag is under way.
         Let it survive a release once - a pointerup swallowed by a context menu, a release off
         the window, capture handed elsewhere - and merely moving the mouse across the bar
         scrolls the row. event.buttons is ground truth: 0 means nothing is held. Treating that
         as a release repairs the stuck state, not just ignores it. */
      if (event.buttons === 0) {
        if (this.dragging) this.onUp(event);
        return;
      }

      if (!this.dragging) return;

      /* A few pixels of wobble between press and release is a click, not a drag - without this
         threshold the glide is cancelled by the very hand that started it. */
      if (!this.moved && Math.abs(event.clientX - this.downX) < 3) return;
      this.moved = true;

      /* A drag tracks the pointer, so it takes over from the glide. */
      this.stopGlide();
      event.preventDefault();

      const spot = this.targetFor(event);
      if (spot) this.track.scrollLeft = spot.raw;
    }

    onUp(event) {
      if (!this.dragging) return;
      this.dragging = false;
      if (this.section) this.section.removeAttribute('data-dk-bs-dragging');

      if (event && event.pointerId !== undefined && this.bar.hasPointerCapture(event.pointerId)) {
        this.bar.releasePointerCapture(event.pointerId);
      }
    }
  }

  if (!customElements.get('deskon-bestsellers-carousel')) {
    customElements.define('deskon-bestsellers-carousel', DeskonBestsellersCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
  /* Deskon - the social gallery's scroll bar and its self-playing videos.

     THE BAR IS A SCROLL INDICATOR, NOT A PROGRESS METER: the fill's WIDTH is the share of the row
     that is on screen, its OFFSET how far that view has travelled. Both are measured against
     scrollWidth, never against the number of cards.

     ---------------------------------------------------------------------------------------------
     THE GLIDE IS PORTED FROM sections/deskon-bestsellers.liquid, ON PURPOSE AND ALMOST LINE FOR
     LINE. The first version of this element jumped straight to a click's destination and carried a
     note saying that if a glide were ever wanted it should be copied from Bestsellers rather than
     invented a second time. This is that copy. THE TWO SECTIONS NOW BEHAVE IDENTICALLY ON THE BAR -
     a fix to one is a fix worth carrying to the other, and a change to one that is not carried
     across is how they start to diverge.

       targetFor   where a pointer is asking the row to go, grabbing the MIDDLE of the fill rather
                   than its leading edge, so the thumb stays under the finger instead of jumping.
       nearestCard rounds that destination to a whole card BEFORE gliding, so snapping can come
                   back on at the end without a second little jump.
       glideTo     a short cubic ease-out of our own, driven by requestAnimationFrame.
       stopGlide   because a drag has to take over from a glide already in flight.

     WHY NOT scrollTo({ behavior: 'smooth' }): the native easing scales with distance and reaches
     half a second across a long row. This duration is fixed, and it is a variable in the stylesheet.

     TWO ATTRIBUTES SUSPEND SNAPPING, NOT ONE. data-dk-sg-dragging comes off at pointerup, which
     usually happens while the glide is still running - mandatory snapping would come back mid-flight
     and fight it to a stop. data-dk-sg-gliding covers exactly that window. The stylesheet must keep
     both in its selector.
     ---------------------------------------------------------------------------------------------
     THE FRAME BUDGET, AND WHAT IT COST TO GET IT. A first version of this glide measured 30-55ms a
     frame on a real machine - about 25fps against a 16ms budget - and the frames were being spent
     on LAYOUT, not on the animation. Three things fixed it, and undoing any one of them brings the
     stutter back:

     1. THE GEOMETRY IS CACHED, NOT READ PER FRAME. scrollWidth and clientWidth force a synchronous
        layout of the whole track - eight cards and their images - and the old update() read both on
        every scroll event, which fires once per glide frame. They are now measured in measure() and
        only re-measured when something can actually have changed them. A LAYOUT READ INSIDE A
        SCROLL HANDLER IS THE EXPENSIVE MISTAKE HERE; do not put one back.

     2. THE THUMB IS DRAWN WITH A TRANSFORM, NOT WITH width AND inset. Percentage width and offset
        are layout properties: writing them invalidated layout again, immediately after the read
        above, which is the classic read-write-read thrash. translateX + scaleX are handled by the
        compositor - no layout, no repaint of the bar at all.

     3. THE GLIDE PAINTS FROM ITS OWN TICK. It already knows the scroll position it just wrote, so
        it passes that number straight to paint() instead of waiting for the scroll event to come
        back and read it off the element.

     RESIZE OBSERVER IS NOT ENOUGH TO CATCH A LATE IMAGE. The track's border box never changes when
     an image finishes loading - the track is always the section's full width - so the observer
     stays silent while scrollWidth grows underneath it. The load listener is capturing, because
     load does not bubble from an <img>.
     ---------------------------------------------------------------------------------------------
     fillRatio IS CACHED AND SHARED BY THE PAINT AND THE HIT TEST, and that is not tidiness.
     paint() draws the thumb and targetFor() decides where a pointer landed on it; two copies of the
     same expression would let the 6% floor or the scale be applied in one and not the other, and
     the thumb would drift out from under the finger by a few pixels per drag.

     THE SCROLL PADDING HAS TO BE SUBTRACTED IN nearestCard. A cell's rect gives its position from
     the track's border box, but the resting scrollLeft for the FIRST card is 0 even though that
     card sits --page-margin inside the track - because scroll-padding-inline-start moves the
     snapport. Without the subtraction every glide overshoots by exactly the page margin.

     THE DIALS ARE READ ONCE PER RESIZE, NOT PER FRAME. getComputedStyle forces style resolution.

     video.muted IS SET AGAIN FROM SCRIPT even though the attribute is in the markup. Safari decides
     whether a muted autoplay is allowed from the PROPERTY; the attribute alone is not enough and
     the promise is rejected. A rejection (Low Power Mode on iOS, for one) is caught and the card
     simply keeps showing its poster.

     THE VIDEOS PLAY ONLY WHILE NEAR THE SCREEN (24/10/2026). One IntersectionObserver for the row,
     200px of margin so a video is already moving when it slides in. Leaving the viewport pauses it,
     vertically or sideways along the row, so at most the three or four cards on screen decode at
     once. preload="none" in the markup means nothing is fetched before the first intersection.
     With prefers-reduced-motion the videos do not start by themselves: a tap plays or pauses one. */
  class SocialGalleryRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dk-sg-track]');
      this.bar = this.querySelector('[data-dk-sg-bar]');
      this.fill = this.querySelector('[data-dk-sg-fill]');
      if (!this.track || !this.bar || !this.fill) return;

      this.dragging = false;
      this.moved = false;
      this.downX = 0;
      this.frame = null;
      this.scale = 1;
      this.smooth = false;
      this.glideMs = 240;
      this.pad = 0;
      this.maxScroll = 0;
      this.ratio = 1;

      this.onScroll = this.onScroll.bind(this);
      this.remeasure = this.remeasure.bind(this);
      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.onClick = this.onClick.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('load', this.remeasure, true);
      this.bar.addEventListener('pointerdown', this.onDown);
      this.bar.addEventListener('pointermove', this.onMove);
      this.bar.addEventListener('pointerup', this.onUp);
      this.bar.addEventListener('pointercancel', this.onUp);
      this.bar.addEventListener('lostpointercapture', this.onUp);
      this.addEventListener('click', this.onClick);

      this.calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const videos = this.querySelectorAll('[data-dk-sg-video]');
      videos.forEach((video) => {
        video.muted = true;
      });
      if (!this.calm && videos.length && 'IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.muted = true;
                const started = video.play();
                if (started && started.catch) started.catch(() => {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '200px' }
        );
        videos.forEach((video) => this.videoObserver.observe(video));
      }

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.remeasure);
        this.observer.observe(this.track);
      }

      this.remeasure();
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('load', this.remeasure, true);
      }
      this.removeEventListener('click', this.onClick);
      if (this.observer) this.observer.disconnect();
      if (this.videoObserver) this.videoObserver.disconnect();
      this.stopGlide();
    }

    /* A viewport change always changes the track's width, so this is also where a breakpoint's
       values for the three dials get picked up. */
    remeasure() {
      const styles = getComputedStyle(this);
      const scale = parseFloat(styles.getPropertyValue('--dk-sg-fill-scale'));
      const glide = parseFloat(styles.getPropertyValue('--dk-sg-bar-glide'));

      this.scale = scale > 0 && scale <= 1 ? scale : 1;
      this.smooth = parseFloat(styles.getPropertyValue('--dk-sg-bar-smooth')) === 1;
      this.glideMs = glide > 0 ? glide : 240;

      const trackStyles = getComputedStyle(this.track);
      const pad = parseFloat(
        trackStyles.scrollPaddingInlineStart || trackStyles.scrollPaddingLeft
      );
      this.pad = pad > 0 ? pad : 0;

      this.measure();
      this.paint(this.track.scrollLeft);
    }

    /* THE ONLY PLACE THAT READS LAYOUT. Everything downstream works from these three numbers. */
    measure() {
      const total = this.track.scrollWidth;
      const view = this.track.clientWidth;

      this.maxScroll = total > 0 ? Math.max(0, total - view) : 0;
      this.ratio = total > 0 ? Math.max(0.06, Math.min(1, (view / total) * this.scale)) : 1;

      const idle = this.maxScroll <= 1;
      if (this.bar.hidden !== idle) this.bar.hidden = idle;
    }

    onScroll() {
      /* While a glide is running its own tick already painted this frame - see the note above. */
      if (this.frame) return;
      this.paint(this.track.scrollLeft);
    }

    /* Compositor only: no width, no inset, no layout. transform-origin: left in the stylesheet is
       what makes scaleX grow from the start of the bar rather than from its middle. */
    paint(scrollLeft) {
      if (this.maxScroll <= 1) return;
      const done = Math.min(1, Math.max(0, scrollLeft / this.maxScroll));
      const offset = done * (1 - this.ratio) * 100;
      this.fill.style.transform = 'translateX(' + offset + '%) scaleX(' + this.ratio + ')';
    }

    targetFor(event) {
      const rect = this.bar.getBoundingClientRect();
      if (!rect.width || this.maxScroll <= 0) return null;

      const fillWidth = this.ratio * rect.width;
      const travel = rect.width - fillWidth;
      if (travel <= 0) return null;

      const offset = Math.max(0, Math.min(travel, event.clientX - rect.left - fillWidth / 2));
      return { raw: (offset / travel) * this.maxScroll, maxScroll: this.maxScroll };
    }

    /* MEASURED FROM RECTS, NOT offsetLeft, which is relative to the nearest POSITIONED ancestor -
       the track is not positioned, so it would land the row in the wrong place. This one forced
       layout is paid once per click, not once per frame. */
    nearestCard(raw, maxScroll) {
      const base = this.track.scrollLeft - this.track.getBoundingClientRect().left - this.pad;
      let best = raw;
      let closest = Infinity;

      for (const cell of this.track.children) {
        const at = cell.getBoundingClientRect().left + base;
        const distance = Math.abs(at - raw);
        if (distance < closest) {
          closest = distance;
          best = at;
        }
      }

      return Math.max(0, Math.min(maxScroll, best));
    }

    glideTo(target) {
      const track = this.track;
      const from = track.scrollLeft;
      const delta = target - from;

      this.stopGlide();
      if (Math.abs(delta) < 1) {
        track.scrollLeft = target;
        this.paint(target);
        return;
      }

      this.setAttribute('data-dk-sg-gliding', '');

      const duration = this.glideMs || 240;
      let started = null;

      const step = (now) => {
        if (started === null) started = now;
        const t = Math.min(1, (now - started) / duration);
        /* Cubic ease-out: it leaves immediately and settles softly, which is the shape that reads
           as light. An ease-in-out would feel hesitant over so short a distance. */
        const at = from + delta * (1 - Math.pow(1 - t, 3));

        track.scrollLeft = at;
        this.paint(at);

        if (t < 1) {
          this.frame = requestAnimationFrame(step);
        } else {
          this.frame = null;
          this.stopGlide();
        }
      };

      this.frame = requestAnimationFrame(step);
    }

    stopGlide() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      this.removeAttribute('data-dk-sg-gliding');
    }

    /* PRIMARY BUTTON ONLY: a right- or middle-click emits pointerdown but sends its pointerup to
       the context menu. See onMove for why an unreported release is the danger. */
    onDown(event) {
      if (event.button !== 0 || !event.isPrimary) return;
      if (this.bar.hidden) return;

      this.dragging = true;
      this.moved = false;
      this.downX = event.clientX;
      this.setAttribute('data-dk-sg-dragging', '');

      try {
        this.bar.setPointerCapture(event.pointerId);
      } catch (e) {}

      const spot = this.targetFor(event);
      if (!spot) return;

      if (this.smooth) {
        this.glideTo(this.nearestCard(spot.raw, spot.maxScroll));
      } else {
        this.track.scrollLeft = spot.raw;
        this.paint(spot.raw);
      }
    }

    onMove(event) {
      /* pointermove FIRES ON HOVER, so our own flag is not enough to know a drag is under way.
         Let it survive a release once - a pointerup swallowed by a context menu, a release off the
         window, capture handed elsewhere - and merely moving the mouse across the bar scrolls the
         row. event.buttons is ground truth: 0 means nothing is held. */
      if (event.buttons === 0) {
        if (this.dragging) this.onUp(event);
        return;
      }

      if (!this.dragging) return;

      /* A few pixels of wobble between press and release is a click, not a drag - without this
         threshold the glide is cancelled by the very hand that started it. */
      if (!this.moved && Math.abs(event.clientX - this.downX) < 3) return;
      this.moved = true;

      /* A drag tracks the pointer, so it takes over from the glide. */
      this.stopGlide();
      event.preventDefault();

      const spot = this.targetFor(event);
      if (spot) {
        this.track.scrollLeft = spot.raw;
        this.paint(spot.raw);
      }
    }

    onUp(event) {
      if (!this.dragging) return;
      this.dragging = false;
      this.removeAttribute('data-dk-sg-dragging');

      if (
        event &&
        event.pointerId !== undefined &&
        this.bar.hasPointerCapture &&
        this.bar.hasPointerCapture(event.pointerId)
      ) {
        this.bar.releasePointerCapture(event.pointerId);
      }
    }

    /* One listener on the row rather than one per card: cards can be added and removed by the
       theme editor at any time, and a per-card listener would miss every one of them. */
    onClick(event) {
      /* Only with prefers-reduced-motion: everywhere else the videos already play on their own. */
      if (!this.calm) return;
      const card = event.target.closest('[data-dk-sg-video-item]');
      if (!card) return;
      const video = card.querySelector('[data-dk-sg-video]');
      if (!video) return;

      if (!video.paused) {
        video.pause();
        return;
      }
      video.muted = true;
      const started = video.play();
      if (started && started.catch) started.catch(() => {});
    }
  }

  if (!customElements.get('social-gallery-row')) {
    customElements.define('social-gallery-row', SocialGalleryRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    
  /* Deskon - the entrance of the WhatsApp button on product pages (23/10/2026). Timings come from
     the section settings through data attributes, in milliseconds. The delay counts from the page
     being ready. One run per element: dataset.dkWaStarted guards against the editor re-firing
     init on a button that is already on its way in. shopify:section:load re-runs it when the
     section is edited, on the fresh element the editor swaps in. */
  (() => {
    const run = (el) => {
      if (el.dataset.dkWaStarted) return;
      el.dataset.dkWaStarted = '1';

      const delay = parseInt(el.dataset.dkWaDelay, 10) || 0;
      const hold = parseInt(el.dataset.dkWaHold, 10) || 3000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.setTimeout(() => {
        el.classList.add('is-in');
        if (!el.querySelector('.dk-wa__label')) return;

        window.setTimeout(() => {
          el.classList.add('is-asking');
          window.setTimeout(() => el.classList.remove('is-asking'), hold);
        }, reduce ? 0 : 700);
      }, delay);
    };

    const init = () => document.querySelectorAll('.dk-wa--intro').forEach(run);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
